export const FATED_ID_OFFSET = 100000000; // fated bosses and raids are offset by this amount
